export default __webpack_public_path__ + "1818362cac5af5060d49e0c8d52b5790.png";